if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('[data-read-more-content]');
      this.toggle = this.querySelector('[data-read-more-toggle]');
      this.toggleLabel = this.toggle?.querySelector('span');
      this.isExpanded = false;

      if (this.toggle) {
        this.toggle.addEventListener('click', this.toggleContent.bind(this));
      }
      
      // Delay initialization to ensure styles are applied
      setTimeout(() => this.init(), 100);
    }

    init() {
      if (!this.content) return;

      const lines = this.dataset.lines || '3';
      const styles = this.content.dataset.readMoreStyles;
      const originalStyle = this.content.getAttribute('data-original-style') || '';

      // Apply initial truncation styles
      this.content.style.cssText = originalStyle + styles;

      const isTruncated = this.content.scrollHeight > this.content.clientHeight;
      if (isTruncated) {
        if (this.toggle) this.toggle.style.display = 'block';
      } else {
        // If not truncated, reset styles to original
        this.content.style.cssText = originalStyle;
        if (this.toggle) this.toggle.style.display = 'none';
      }
    }

    toggleContent(event) {
      if (event) event.preventDefault();
      this.isExpanded = !this.isExpanded;
      
      const originalStyle = this.content.getAttribute('data-original-style') || '';
      const styles = this.content.dataset.readMoreStyles;

      if (this.isExpanded) {
        this.content.style.cssText = originalStyle;
        if (this.toggleLabel) this.toggleLabel.textContent = this.toggle.dataset.labelLess;
        this.setAttribute('expanded', '');
      } else {
        this.content.style.cssText = originalStyle + styles;
        if (this.toggleLabel) this.toggleLabel.textContent = this.toggle.dataset.labelMore;
        this.removeAttribute('expanded');
      }
    }
  }

  customElements.define('read-more', ReadMore);
}